/**
 * /tracking/sdk-custom-params — operator page for feature #205.
 *
 * Declares a TanStack Router route and renders `SdkCustomParamsPage`. The
 * root wire-up cycle picks this route up after the prod merge; agents
 * never edit router.tsx directly.
 */
import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { SdkCustomParamsPage } from "@/features/sdk-custom-params/SdkCustomParamsPage";

// ---------------------------------------------------------------------------
// Route — mounts at `/tracking/sdk-custom-params`.
// ---------------------------------------------------------------------------

export const trackingSdkCustomParamsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/tracking/sdk-custom-params",
	component: TrackingSdkCustomParamsRoute,
});

export default trackingSdkCustomParamsRoute;

// ---------------------------------------------------------------------------
// Page shell — breadcrumb + feature component.
// ---------------------------------------------------------------------------

export function TrackingSdkCustomParamsRoute() {
	return (
		<div className="mx-auto flex w-full max-w-6xl flex-col gap-4 px-6 pt-6 sm:pt-10">
			<Breadcrumb />
			<SdkCustomParamsPage />
		</div>
	);
}

function Breadcrumb() {
	return (
		<nav aria-label="Breadcrumb" className="text-sm text-zinc-500">
			<ol className="flex flex-wrap items-center gap-1">
				<li>
					<Link
						to="/"
						className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
					>
						Dashboard
					</Link>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li>
					<span className="rounded-[6px] px-1 py-0.5">Tracking</span>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li className="text-zinc-900">SDK custom params</li>
			</ol>
		</nav>
	);
}

// Named export for the root wire-up cycle.
export { TrackingSdkCustomParamsRoute as TrackingSdkCustomParamsPage };
